import * as React from 'react';
import { Entity, EntityType } from '../../../data/types';
import { saveTestsSetting } from '../../../data/writers/settings/testsSetting';
import { useInfiniteTests } from '../../../hooks/Tests/useInfiniteTests';
import { ScrollableArea } from '../../layout/ScrollableArea';
import { ListControlLabel } from '../../shared/form/ListControlLabel';
import { ListControlContainer } from '../../shared/List/ListControlContainer';
import { ExportList } from './ExportList';

interface IProps {
  entity: Entity;
  entityType: EntityType;
}

export const Tests = (props: IProps): React.ReactElement => {
  const {
    tests,
    testsLoading,
    setStartAfter,
    onEntityChange,
    updateInPlace,
    dateRange,
    showDisabledTests,
    facet,
  } = useInfiniteTests({
    entityId: props.entity?.id,
    entityType: props.entityType,
  });

  React.useEffect((): void => {
    onEntityChange({
      entityId: props.entity?.id,
      entityType: props.entityType,
    });
  }, [props.entity?.id, props.entityType]);

  const clearDateRange = (): Promise<void> => saveTestsSetting({ range: null });
  const clearFacet = (): Promise<void> => saveTestsSetting({ facet: null });

  return (
    <React.Fragment>
      <ListControlLabel label='Tests' />
      <ListControlContainer>
        <ScrollableArea
          style={{
            flex: 1,
          }}
        >
          <ExportList
            data={tests}
            loading={testsLoading}
            onMore={setStartAfter}
            entity={props.entity}
            entityType={props.entityType}
            dateRange={dateRange}
            clearDateRange={clearDateRange}
            clearFacet={clearFacet}
            facet={facet}
            updateTests={updateInPlace}
            showDisabledTests={showDisabledTests}
            toggleArchivedTests={(): void =>
              onEntityChange({
                showDisabledTests: !showDisabledTests,
                entityId: props.entity?.id,
                entityType: props.entityType,
              })
            }
          />
        </ScrollableArea>
      </ListControlContainer>
    </React.Fragment>
  );
};
